import React from 'react';
import { IconSvgProps } from '@models/common';

const NavGrammar: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M19.0369 12.2643V6.47644C19.0369 5.87997 19.5209 5.39597 20.1173 5.39597C20.7138 5.39597 21.1978 5.87997 21.1978 6.47644V12.2643C21.1975 12.8606 20.7136 13.3436 20.1173 13.3436C19.521 13.3436 19.0372 12.8606 19.0369 12.2643Z'
        fill='currentColor'
      />
      <path
        d='M19.0375 9.3698C19.0373 8.36828 18.225 7.55691 17.2234 7.55691C16.222 7.55709 15.4107 8.36839 15.4105 9.3698C15.4105 10.3714 16.2219 11.1837 17.2234 11.1839C18.2251 11.1839 19.0375 10.3715 19.0375 9.3698ZM21.1972 9.3698C21.1972 11.5644 19.418 13.3436 17.2234 13.3436C15.0289 13.3434 13.2496 11.5643 13.2496 9.3698C13.2497 7.17545 15.0291 5.39615 17.2234 5.39597C19.4179 5.39597 21.197 7.17534 21.1972 9.3698Z'
        fill='currentColor'
      />
      <path
        d='M8.86178 12.2637V5.38249C8.86169 4.74259 8.60755 4.1288 8.15514 3.67624C7.70248 3.22359 7.08786 2.9696 6.44772 2.9696C5.80768 2.96969 5.19404 3.22367 4.74147 3.67624C4.28889 4.12882 4.03491 4.74246 4.03483 5.38249V12.2637C4.03483 12.8602 3.55082 13.3442 2.95436 13.3442C2.35789 13.3442 1.87389 12.8602 1.87389 12.2637V5.38249C1.87397 4.1696 2.35686 3.00695 3.21451 2.14929C4.07217 1.29164 5.23482 0.808752 6.44772 0.808667C7.66073 0.808667 8.82436 1.29156 9.68209 2.14929C10.5396 3.00692 11.0215 4.16972 11.0215 5.38249V12.2637C11.0215 12.86 10.5385 13.3439 9.94225 13.3442C9.34578 13.3442 8.86178 12.8602 8.86178 12.2637Z'
        fill='currentColor'
      />
      <path
        d='M9.94225 7.00181C10.5385 7.00209 11.0215 7.48598 11.0215 8.08227C11.0215 8.67857 10.5385 9.16246 9.94225 9.16274H2.95436C2.35789 9.16274 1.87389 8.67874 1.87389 8.08227C1.87389 7.48581 2.35789 7.00181 2.95436 7.00181H9.94225Z'
        fill='currentColor'
      />
      <path
        d='M10.8387 19.8125C11.4352 19.8125 11.9192 20.2965 11.9192 20.8929C11.9192 21.4894 11.4352 21.9734 10.8387 21.9734H2.95436C2.35789 21.9734 1.87389 21.4894 1.87389 20.8929C1.87389 20.2965 2.35789 19.8125 2.95436 19.8125H10.8387Z'
        fill='currentColor'
      />
      <path
        d='M15.6083 15.5695C16.2047 15.5695 16.6887 16.0535 16.6887 16.65C16.6887 17.2465 16.2047 17.7305 15.6083 17.7305H2.95436C2.35789 17.7305 1.87389 17.2465 1.87389 16.65C1.87389 16.0535 2.35789 15.5695 2.95436 15.5695H15.6083Z'
        fill='currentColor'
      />
      <path
        d='M20.2621 17.809C20.6722 17.376 21.356 17.3578 21.789 17.768C22.222 18.1781 22.2402 18.8619 21.83 19.2949L18.1925 23.1352C17.9922 23.3467 17.7151 23.4685 17.4238 23.4727C17.1323 23.4766 16.8506 23.3624 16.6445 23.1562L14.8445 21.3562C14.4232 20.9345 14.4231 20.251 14.8445 19.8293C15.2663 19.4075 15.9509 19.4075 16.3726 19.8293L17.3875 20.8441L20.2621 17.809Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default NavGrammar;
